module.exports = __webpack_public_path__ + "static/media/close-red.c20acd82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/close-red.svg
// module id = 496
// module chunks = 0